import { ClassStudent, Roles } from '../types';

// Static list of 30 students, 1 teacher, and 2 assistants
export const studentsDemoData: ClassStudent[] = [
    {
        student_uuid: '1',
        student_id: '1',
        first_name: 'Anne',
        last_name: 'Malley',
        role: Roles.Teacher,
        user_name: 'Anne Malley',
        meeting_id: '93084561346',
        email: 'anne.anne@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '2',
        student_id: '2',
        first_name: 'James',
        last_name: 'Lloyd',
        role: Roles.Assistant,
        user_name: 'James Lloyd',
        meeting_id: '93084561346',
        email: 'james.james@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '3',
        student_id: '3',
        first_name: 'Huey',
        last_name: 'Le',
        role: Roles.Student,
        user_name: 'Huey Le',
        meeting_id: '93084561346',
        email: 'huey.huey@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '4',
        student_id: '4',
        first_name: 'Lindsay',
        last_name: 'Rayne',
        role: Roles.Student,
        user_name: 'Lindsay Rayne',
        meeting_id: '93084561346',
        email: 'lindsay.lindsay@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '5',
        student_id: '5',
        first_name: 'Timothy',
        last_name: 'French',
        role: Roles.Student,
        user_name: 'Timothy French',
        meeting_id: '93084561346',
        email: 'timothy.timothy@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '6',
        student_id: '6',
        first_name: 'Tia',
        last_name: 'Ford',
        role: Roles.Student,
        user_name: 'Tia Ford',
        meeting_id: '93084561346',
        email: 'tia.tia@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '7',
        student_id: '7',
        first_name: 'Jimmy',
        last_name: 'Li',
        role: Roles.Student,
        user_name: 'Jimmy Li',
        meeting_id: '93084561346',
        email: 'jimmy.jimmy@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '8',
        student_id: '8',
        first_name: 'Kurt',
        last_name: 'Franklin',
        role: Roles.Student,
        user_name: 'Kurt Franklin',
        meeting_id: '93084561346',
        email: 'kurt.kurt@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '9',
        student_id: '9',
        first_name: 'Vanessa',
        last_name: 'Perry',
        role: Roles.Student,
        user_name: 'Vanessa Perry',
        meeting_id: '93084561346',
        email: 'vanessa.vanessa@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '10',
        student_id: '10',
        first_name: 'Chaya',
        last_name: 'Meyer',
        role: Roles.Assistant,
        user_name: 'Chaya Meyer',
        meeting_id: '93084561346',
        email: 'chaya.chaya@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '11',
        student_id: '11',
        first_name: 'Penelope',
        last_name: 'Schultz',
        role: Roles.Student,
        user_name: 'Penelope Schultz',
        meeting_id: '93084561346',
        email: 'penelope.penelope@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '12',
        student_id: '12',
        first_name: 'Nico',
        last_name: 'Lawson',
        role: Roles.Student,
        user_name: 'Nico Lawson',
        meeting_id: '93084561346',
        email: 'nico.nico@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '13',
        student_id: '13',
        first_name: 'Joe',
        last_name: 'Walton',
        role: Roles.Student,
        user_name: 'Joe Walton',
        meeting_id: '93084561346',
        email: 'joe.joe@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '14',
        student_id: '14',
        first_name: 'Cassandra',
        last_name: 'Poole',
        role: Roles.Student,
        user_name: 'Cassandra Poole',
        meeting_id: '93084561346',
        email: 'cassandra.cassandra@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '15',
        student_id: '15',
        first_name: 'Francisco',
        last_name: 'Beck',
        role: Roles.Student,
        user_name: 'Francisco Beck',
        meeting_id: '93084561346',
        email: 'francisco.francisco@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '16',
        student_id: '16',
        first_name: 'Jordan',
        last_name: 'Day',
        role: Roles.Student,
        user_name: 'Jordan Day',
        meeting_id: '93084561346',
        email: 'jordan.jordan@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '17',
        student_id: '17',
        first_name: 'Kayla',
        last_name: 'Becker',
        role: Roles.Student,
        user_name: 'Kayla Becker',
        meeting_id: '93084561346',
        email: 'kayla.kayla@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '18',
        student_id: '18',
        first_name: 'Britney',
        last_name: 'Rice',
        role: Roles.Student,
        user_name: 'Britney Rice',
        meeting_id: '93084561346',
        email: 'britney.britney@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '19',
        student_id: '19',
        first_name: 'Suzanne',
        last_name: 'Briggs',
        role: Roles.Student,
        user_name: 'Suzanne Briggs',
        meeting_id: '93084561346',
        email: 'suzanne.suzanne@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '20',
        student_id: '20',
        first_name: 'Lilia',
        last_name: 'Vazquez',
        role: Roles.Student,
        user_name: 'Lilia Vazquez',
        meeting_id: '93084561346',
        email: 'lilia.lilia@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '21',
        student_id: '21',
        first_name: 'Russell',
        last_name: 'Reid',
        role: Roles.Student,
        user_name: 'Russell Reid',
        meeting_id: '93084561346',
        email: 'russell.russell@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '22',
        student_id: '22',
        first_name: 'Luna',
        last_name: 'Trujillo',
        role: Roles.Student,
        user_name: 'Luna Trujillo',
        meeting_id: '93084561346',
        email: 'luna.luna@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '23',
        student_id: '23',
        first_name: 'Judie',
        last_name: 'Ray',
        role: Roles.Student,
        user_name: 'Judie Ray',
        meeting_id: '93084561346',
        email: 'judie.judie@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '24',
        student_id: '24',
        first_name: 'Molly',
        last_name: 'Huber',
        role: Roles.Student,
        user_name: 'Molly Huber',
        meeting_id: '93084561346',
        email: 'molly.molly@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '25',
        student_id: '25',
        first_name: 'Donald',
        last_name: 'Hardy',
        role: Roles.Student,
        user_name: 'Donald Hardy',
        meeting_id: '93084561346',
        email: 'donald.donald@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '26',
        student_id: '26',
        first_name: 'Tom',
        last_name: 'Galloway',
        role: Roles.Student,
        user_name: 'Tom Galloway',
        meeting_id: '93084561346',
        email: 'tom.tom@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '27',
        student_id: '27',
        first_name: 'Carly',
        last_name: 'Perkins',
        role: Roles.Student,
        user_name: 'Carly Perkins',
        meeting_id: '93084561346',
        email: 'carly.carly@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '28',
        student_id: '28',
        first_name: 'Sandie',
        last_name: 'Cochran',
        role: Roles.Student,
        user_name: 'Sandie Cochran',
        meeting_id: '93084561346',
        email: 'sandie.sandie@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '29',
        student_id: '29',
        first_name: 'Rob',
        last_name: 'Lily',
        role: Roles.Student,
        user_name: 'Rob Lily',
        meeting_id: '93084561346',
        email: 'rob.rob@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '30',
        student_id: '30',
        first_name: 'Tory',
        last_name: 'Harrell',
        role: Roles.Student,
        user_name: 'Tory Harrell',
        meeting_id: '93084561346',
        email: 'tory.tory@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '31',
        student_id: '31',
        first_name: 'Nick',
        last_name: 'Simpson',
        role: Roles.Student,
        user_name: 'Nick Simpson',
        meeting_id: '93084561346',
        email: 'nick.nick@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '32',
        student_id: '32',
        first_name: 'Elizabeth',
        last_name: 'Everett',
        role: Roles.Student,
        user_name: 'Elizabeth Everett',
        meeting_id: '93084561346',
        email: 'elizabeth.elizabeth@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    },
    {
        student_uuid: '33',
        student_id: '33',
        first_name: 'Ann',
        last_name: 'Gray',
        role: Roles.Student,
        user_name: 'Ann Gray',
        meeting_id: '93084561346',
        email: 'ann.ann@school.com',
        ext_user_id: '',
        seed: 0,
        user_image: ''
    }
];
